<template>
  <div class="container">
    <div class="row text--base">
      <AseanFunding :content="aseanFundinContent" />
    </div>
  </div>
</template>

<script>
import { json as fetchJson } from 'd3';
import AseanFunding from '@/components/content/AseanFunding.vue';

export default {
  name: 'App1BubbleCluster',
  components: {
    AseanFunding,
  },
  data() {
    return {
      content: {},
    };
  },
  computed: {
    aseanFundinContent() {
      return this.content.sections ? this.content.sections.find((d) => d.id === 'asean-funding') : {};
    },
  },
  async created() {
    this.content = await fetchJson(`${process.env.BASE_URL}data/content/chapter-01.json`);
  }
};
</script>

<style scoped>
.container {
  background-color: #f4f6fd;
}
</style>